"use strict";
var TooltipDelay;
(function (TooltipDelay) {
    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
    TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
})(TooltipDelay = exports.TooltipDelay || (exports.TooltipDelay = {}));

//# sourceMappingURL=Tooltip.Props.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Tooltip/Tooltip.Props.js
// module id = 276
// module chunks = 0